import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  remindersContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px'
  },
  // Classe condicional para a margem
  remindersMargin: {
    marginBottom: '8px'
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  iconButtonAdd: {
    padding: 0,
    marginTop: '4px',
    color: theme.palette.white_100.main,
    background: theme.palette.green_200.main,
    borderRadius: '8px',
    height: '40px',
    width: '40px',
    '&:hover': {
      background: theme.palette.blue_300.main
    },
    '&:disabled': {
      background:
        theme.palette.type === 'dark'
          ? theme.palette.dark_300.main
          : theme.palette.gray_300.main,
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main,
      cursor: 'not-allowed'
    }
  },

  inputAutocomplete: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,

    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& .MuiOutlinedInput-input': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      fontSize: '1rem',
      fontFamily: 'Inter, sans-serif',
      fontWeight: '400',
      lineWeight: '1'
    }
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      '& .MuiOutlinedInput-input': {
        // padding: '10px !important',
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main
      }
    },
    '& label': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  chip: {
    borderRadius: '4px',
    textTransform: 'uppercase'
  },
  popupIcon: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50?.main
        : theme.palette.gray_400?.main
  },

  // Estilo para o texto dentro da lista suspensa
  optionText: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50?.main
        : theme.palette.gray_400?.main,
    fontFamily: 'Inter, sans-serif', // Opcional: mantendo a consistência da fonte
    fontSize: '0.9rem'
  },
  inputContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  // Estilos dos Chips baseados na regra de negócio
  chips: {
    color: theme.palette.white_100.main,
    borderRadius: '4px',
    fontSize: '0.7rem',
    height: '20px',
    '& .MuiChip-deleteIcon': {
      color: 'rgba(255, 255, 255, 0.7)'
    },
    '& .MuiChip-deleteIcon:hover': {
      color: theme.palette.white_100.main
    }
  },
  chipBefore: {
    backgroundColor: theme.palette.orange_600.main
  },
  chipAfter: {
    backgroundColor: theme.palette.blue_300.main
  },
  chipExact: {
    backgroundColor: theme.palette.green_200.main
  }
}))
